import Overview from '@rebuild/materials/shared/customs_calendar/CardOverview.vue';
import Full from '@rebuild/materials/shared/customs_calendar/FullIndex.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/customs_calendar/context';

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(Full, useSelfContext)
};

function useSelfContext() {
	provideCurrentContext();
}
